import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { mainSiteUrl } from '@/mocks/categories';

export default function ArticleSection() {
  const { t } = useTranslation();

  return (
    <>
      <section className="bg-background-50">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-20">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl font-heading">{t('articlesTitle')}</h2>
            <p className="mt-3 text-sm text-foreground-600 md:text-base">{t('articlesSubtitle')}</p>
          </div>

          <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {articles.map((a) => (
              <Link
                key={a.slug}
                to={`/articles/${a.slug}`}
                className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
              >
                <div className="h-36 w-full overflow-hidden">
                  <img
                    src={a.image}
                    alt={t(a.titleKey)}
                    className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <div className="flex items-center justify-between">
                    <span className="inline-flex items-center rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
                      {t(a.tagKey)}
                    </span>
                    <i className="ri-arrow-right-line text-foreground-400 transition-all group-hover:translate-x-1 group-hover:text-primary-600"></i>
                  </div>
                  <h3 className="mt-3 text-base font-semibold leading-snug text-foreground-950 font-heading">
                    {t(a.titleKey)}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{t(a.descKey)}</p>
                  <span className="mt-auto pt-4 text-sm font-semibold text-primary-700">{t('articleReadMore')}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-primary-500">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-20 text-center">
          <h2 className="text-2xl font-bold text-background-50 md:text-4xl font-heading">{t('finalTitle')}</h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm text-background-100 md:text-base">{t('finalCopy')}</p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-background-50 px-6 py-3 text-base font-semibold text-primary-700 hover:bg-background-100 whitespace-nowrap cursor-pointer sm:w-auto"
            >
              <i className="ri-leaf-line"></i>
              {t('usfansSpreadsheet')}
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-accent-500 px-6 py-3 text-base font-semibold text-background-50 hover:bg-accent-600 whitespace-nowrap cursor-pointer sm:w-auto"
            >
              <i className="ri-shopping-cart-line"></i>
              {t('buyNow')}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}